import React, { useEffect, useState } from "react";
import useABExperiment from "hooks/useABExperiment";
import { API_FETCH_STATUS } from "constants/common";

const { LOADING, SUCCESS, ERROR } = API_FETCH_STATUS;

const ExperimentComponent = ({ experimentState, VariantComponentA, VariantComponentB, props }) => {
  if (
    (experimentState.state === SUCCESS && experimentState.contents.experiment.variant === "A") ||
    experimentState.state === ERROR
  ) {
    return <VariantComponentA {...props} />;
  } else if (experimentState.contents.experiment.variant === "B") {
    return <VariantComponentB {...props} />;
  }
};

const withABExperiment = ({ VariantComponentA, VariantComponentB, experimentName }) => {
  return (props) => {
    const { fetchExperimentDetails, experimentState } = useABExperiment(experimentName);
    useEffect(() => {
      if(!experimentState?.contents?.experiment){
        fetchExperimentDetails();
      }
    }, []);

    if (experimentState.state === LOADING) {
      return null;
    }

    return <ExperimentComponent {...{ experimentState, VariantComponentA, VariantComponentB, props }} />;
  };
};

export default withABExperiment;
